export default "__VITE_ASSET__Blckl9Ov__"